import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { HuismapType, MijnOverzichtResource } from '@ap/interface-apix-mijn-overzicht';

import { MijnOmgevingNavigation } from '../../mijn-omgeving.navigation';

export const HUISMAP_URL = '/online/huismap/';

@Injectable({ providedIn: 'root' })
export class PegaHuismapGuard {
    public constructor(
        private readonly mijnOverzichtResource: MijnOverzichtResource,
        private readonly mijnOmgevingNavigation: MijnOmgevingNavigation
    ) {}

    public canActivate(): Observable<boolean> {
        return this.mijnOverzichtResource.getHuismap().pipe(
            switchMap((result) => {
                if (result.huismap_type !== HuismapType.PEGA) {
                    this.mijnOmgevingNavigation.external(HUISMAP_URL);
                    return of(false);
                }
                return of(true);
            }),
            catchError(() => {
                this.mijnOmgevingNavigation.external(HUISMAP_URL);
                return of(false);
            })
        );
    }
}
